import { useQuery } from '@tanstack/react-query'
import { getAbsenceOverview } from '../api/absences'
import { useAuthStore } from '../store/authStore'
import { usePermissionsStore } from '../store/permissionsStore'
import { can } from '../utils/permissions'
import type { NavItem } from './navigation'

/** Počet žádostí o nepřítomnost čekajících na schválení (menu, záložka Ke schválení). */
export function usePendingAbsenceCount(enabled = true) {
  return useQuery({
    queryKey: ['absences', 'pendingCount'],
    queryFn: () => getAbsenceOverview({ status: 'pending', per_page: 1 }),
    select: (d) => d.pagination.total,
    enabled,
    staleTime: 30_000,
    refetchInterval: 120_000,
  })
}

/** Odznak s počtem u položky menu (jen když je co dělat; 0 se neukazuje). */
export default function NavBadge({ kind }: { kind: NonNullable<NavItem['badge']> }) {
  const user = useAuthStore((s) => s.user)
  usePermissionsStore((s) => s.capabilities)
  const enabled = kind === 'absencesPending' && can(user, 'attendance.absenceApprove')
  const { data } = usePendingAbsenceCount(enabled)
  if (!enabled || !data) return null
  return (
    <span className="ml-auto inline-flex min-w-[1.5rem] items-center justify-center rounded-full bg-brand-600 px-1.5 py-0.5 text-xs font-semibold tabular-nums text-white">
      <span className="sr-only">ke schválení: </span>{data}
    </span>
  )
}
